import { render } from "./SkinSlotA.vue?vue&type=template&id=0d4ce0f6&scoped=true&ts=true"
import script from "./SkinSlotA.vue?vue&type=script&lang=ts"
export * from "./SkinSlotA.vue?vue&type=script&lang=ts"

import "./SkinSlotA.vue?vue&type=style&index=0&id=0d4ce0f6&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4ce0f6"]])

export default __exports__